export default "__VITE_ASSET__Dr2D8C0l__"